import React from 'react';
import '../styles/CreateCompany.css';
import { Input } from '../components';

function CreateCompany(props) {
    const companyName = props.companyName;
    const onChangeCompanyName = props.onChangeCompanyName;
    const adminUserId = props.adminUserId;
    const onChangeAdminUserId = props.onChangeAdminUserId;
    return (
        <div className="create-company-container">
            <Input
                label={"Company name"}
                labelType={"default"}
                secondaryLabelGrey={null}
                info={false}
                value={companyName}
                onChange={onChangeCompanyName}
                placeholder={"ACME Inc."}
                type="text"
                leftUnit={null}
                rightUnit={null}
                unitSwitch={false}
                leftUnitSelected={true}
                unitSwitchFunc={null}
                disabled={false}
                multiline={false}
                error={false}
                onMouseEnter={null}
                onMouseLeave={null}
                reset={false}
                resetFunc={null}
                resetPosition={null}
                focusMultiline={false}
                prompt={false}
            />
            <Input
                label={"Admin User ID"}
                labelType={"default"}
                secondaryLabelGrey={null}
                info={false}
                value={adminUserId}
                onChange={onChangeAdminUserId}
                placeholder={"ABC123"}
                type="text"
                leftUnit={null}
                rightUnit={null}
                unitSwitch={false}
                leftUnitSelected={true}
                unitSwitchFunc={null}
                disabled={false}
                multiline={false}
                error={false}
                onMouseEnter={null}
                onMouseLeave={null}
                reset={false}
                resetFunc={null}
                resetPosition={null}
                focusMultiline={false}
                prompt={false}
            />
        </div>
    )
};

export default CreateCompany;